import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { getAppsflyerFromCookie } from '@dragonfruit/utils/appsflyers';

import {
  apiCheckoutBuildPending,
  apiCheckout2C2P,
  apiGet2C2PBanks,
} from '@dragonfruit/services/apis';

import { actions, types } from '@dragonfruit/redux/purchase/checkout2C2P';
import { showAlertBanner } from '@dragonfruit/redux/alertBanner';
import { setHasSubscription } from '@dragonfruit/redux/plans';
import { getRegionId } from '@dragonfruit/redux/profile';
import { getValidDiscountCode } from '@dragonfruit/redux/discountCode';

import { ALERT_ERROR_THEME } from '@dragonfruit/constants/alertBannerThemes';
import { ALERT_SYSTEMINFO_THEME } from '@dragonfruit/constants/alertBannerThemes';
import { HAS_SUBSCRIPTION_PLAN } from '@dragonfruit/constants/errorCode';
import { PAY_BY_2C2P } from '@dragonfruit/constants/paymentTypes';
import { sendInitialCheckoutEvents } from './purchaseEvents';

export function* initiate2C2pCheckoutEvent(action) {
  const { paymentMethodId, agentCode, gtmData, deliveryInfo } = action;
  const validDiscountCode = yield select(getValidDiscountCode);
  const appsflyerSale = getAppsflyerFromCookie();

  try {
    const {
      currency,
      name,
      planId,
      planType,
      price,
      questionQuota,
      sellingTypes,
      sku,
    } = gtmData;

    // 1. call 2c2p checkout api
    let commonData = {
      agentCode,
      paymentMethodId,
      deliveryInfo,
    };
    if (!!validDiscountCode) {
      commonData.code = validDiscountCode;
    }

    let buildPendingData = { ...commonData };
    if (appsflyerSale) {
      buildPendingData.appsflyerSale = appsflyerSale;
    }

    const {
      payment: { orderNumber },
    } = yield call(apiCheckoutBuildPending, buildPendingData);

    let checkoutData = { ...commonData };
    checkoutData.orderNumber = orderNumber;

    const response = yield call(apiCheckout2C2P, checkoutData);

    const {
      data: {
        payment: {
          orderNumber: orderId,
          formatedAmount: amount,
          paymentOption,
          endpoint: payment2C2PEndpoint,
          currencyCode,
          merchantId,
          version,
          description: paymentDesc,
          payload: hashValue,
        },
      },
    } = response;

    // 2. get hash value
    // backend will handle this hash, but I think it's necessary to put some detail here.
    // hash rule: ref:https://developer.2c2p.com/docs/payment-channel-options
    // `${version}
    // ${merchant_id}
    // ${payment_description}
    // ${order_id}
    // ${currency}
    // ${amount}
    // ${result_url_1}
    // ${payment_option}`
    // const hashValue = HmacSHA1(
    //   `${version}
    //   ${merchantId}
    //   ${description}
    //   ${orderId}
    //   ${currencyCode}
    //   ${amount}
    //   ${callbackEndpoint}
    //   ${paymentOption}`,
    //   secret);
    yield call(sendInitialCheckoutEvents, {
      paymentType: PAY_BY_2C2P,
      sku,
      name,
      price,
      planId,
      currency,
      planType,
      sellingTypes,
      questionQuota,
      paymentMethodId,
    });

    yield put(
      actions.checkout2C2PSuccess({
        orderId,
        amount,
        paymentOption,
        payment2C2PEndpoint,
        currency: currencyCode,
        merchantId,
        version,
        hashValue,
        paymentDesc,
      })
    );
  } catch (error) {
    const { message, error_code } = error;
    yield put(actions.checkout2C2PFail());
    yield put(
      showAlertBanner({
        message,
        theme: ALERT_ERROR_THEME,
      })
    );
    yield put(setHasSubscription(error_code === HAS_SUBSCRIPTION_PLAN));
  }
}

function* get2C2PBanksFlow() {
  const regionId = yield select(getRegionId);
  try {
    const { onlineBankings: banks } = yield call(apiGet2C2PBanks, regionId);

    yield put(actions.get2C2PBanksSuccess(banks));
    // show message for users to avoid browser issue (2C2P S2B solution has issues with ios safari)
    yield put(
      showAlertBanner({
        message: 'purchase:purchase.payBy2C2P.recommendBrowserHint',
        theme: ALERT_SYSTEMINFO_THEME,
        keepAlive: true,
      })
    );
  } catch (error) {
    yield put(actions.get2C2PBanksFail(error));
  }
}

export default function*() {
  yield all([
    takeLatest(types.CHECKOUT_2C2P_REQUEST, initiate2C2pCheckoutEvent),
    takeLatest(types.GET_2C2P_BANKS, get2C2PBanksFlow),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/purchase/checkout2C2P.js